import React from 'react';
import { useTranslation } from 'react-i18next';

const About: React.FC = () => {
  const { t, i18n } = useTranslation();

  // Format launch date based on current locale
  const formatDate = (date: string) => {
    const launchDate = new Date(date);
    launchDate.setHours(launchDate.getHours() + 12);
    return launchDate.toLocaleDateString(i18n.language, { month: 'short', day: 'numeric' });
  };

  return (
    <div className="max-w-6xl mx-auto py-8 sm:py-12 px-4 sm:px-6">
      <h1 className="text-3xl font-bold text-indigo-600 dark:text-indigo-400 mb-6">
        {t('about')}
      </h1>

      <div className="mb-12 grid items-center gap-8 lg:grid-cols-2">
        <img src="/assets/brand/about-syllables-640.webp" srcSet="/assets/brand/about-syllables-640.webp 640w, /assets/brand/about-syllables-1200.webp 1200w" sizes="(min-width: 1024px) 560px, 100vw" alt={t('brand.aboutArt')} width={1536} height={1024} loading="lazy" className="w-full rounded-xl object-cover" />
        <div className="max-w-2xl leading-relaxed text-slate-700 dark:text-slate-300">
          <p className="text-lg mb-8">
            {t('tagline')}
          </p>

          <ul className="list-disc pl-5 mb-8">
            <li
              className="text-lg mb-2"
              dangerouslySetInnerHTML={{
                __html: t('announcement.1', {
                  date: formatDate('2025-04-01'),
                  link_post: 'https://x.com/doganju_com/status/1907006855747924241',
                  link: 'https://doganju.com',
                  linkClass: 'text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline'
                })
              }}
            />
          </ul>

          <p
            className="text-lg mb-8"
            dangerouslySetInnerHTML={{
              __html: t('feedback', {
                link: 'https://x.com/doganju_com',
                linkClass: 'text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline'
              })
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
